export const QUERY_SCORING_QUOTAS = 'QUERY_SCORING_QUOTAS';
export const OPEN_QUERY_SCORING_QUOTA_MODAL = 'OPEN_QUERY_SCORING_QUOTA_MODAL';
export const CLOSE_QUERY_SCORING_QUOTA_MODAL = 'CLOSE_QUERY_SCORING_QUOTA_MODAL';
export const RESET_QUERY_SCORING_DATA = 'RESET_QUERY_SCORING_DATA';